import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface DueInfoProps {
  className?: string;
  cardTitle?: string;
  dueText?: ReactNode;
}

export const DueInfo = styled(
  ({ className, cardTitle, dueText }: DueInfoProps) => (
    <span className={className}>
      <b>{cardTitle}</b> {dueText}
    </span>
  ),
)`
  font-size: 14px;
  margin-left: 8px;
`;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-detail/DueInfo.tsx